<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="materials"
    :search="search"
    sort-by="name"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>MATERIAIS</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="materials.length == 0"
          :href="linkExcel"
          target="_blank"
          color="grey darken-4"
          outlined
          small
          class="mt-3 float-right"
        >
          <v-icon color="green" left> mdi-file-excel-box </v-icon>
          Excel
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import { URL } from "@/api/config";
import * as API from "@/api/requests/MaterialRequest";

export default {
  data: () => ({
    search: "",
    loading: false,
    headers: [
      { text: "Código", value: "code", width: 100 },
      { text: "Nome", value: "name", width: 350 },
    ],
    materials: [],
    lazy: false,
    valid: true,
  }),
  computed: {
    linkExcel() {
      return `${URL}report/report-material`;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getMaterials();
    },
    validate() {},
    async getMaterials() {
      this.loading = true;
      this.materials = [];
      try {
        this.materials = await API.getAll();
        this.materials = this.materials.sort((a, b) =>
          a.name > b.name ? 1 : -1
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
